var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{ref:"root",staticClass:"components__simple-button center",class:_vm.cssClasses(),on:{"click":_vm.buttonClick}},[_c('div',{staticClass:"center"},[_vm._t("default")],2)])}
var staticRenderFns = []

export { render, staticRenderFns }